<div class="row align-items-center justify-content-center login-form-container">

  <div class="col-12">
    <div class="row align-items-center justify-content-center">
      <div class="col-lg-5 col-md-8 col-sm-10 col-12">
        <!-- <div class="card"> -->
        <!-- <div class="card-body p-3"> -->

        <h5 class="card-title mb-1">Choose a New Password</h5>
        <hr class="mt-0 mb-0">
        <div class="mt-3" *ngIf="confirmationCodeMessage"> {{confirmationCodeMessage}} </div>
        <div class="font13-400 mt-3 mb-2 text-danger" *ngIf="isMalformedEmail">
          {{urlParamMissingMsg}}
        </div>

        <div class="font12-400 mt-3 mb-2 text-muted">
          {{passwordRule}}
        </div>

        <form #resetPasswordForm="ngForm" autocomplete="off" novalidate (ngSubmit)="formSubmit(resetPasswordForm)">
          <div class="form-group">
            <label>Confirmation Code</label>
            <input type="text" class="form-control" autocomplete="off" [(ngModel)]="resetPasswordModal.code" name="code"
              #code="ngModel" pattern="[0-9]{6}" oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="6"
              [disabled]="isMalformedEmail" required>
            <small class="text-danger text-center" *ngIf="code.errors && resetPasswordForm.submitted">
              <p class="mb-0" *ngIf="code.errors.required">Code is required</p>
              <p class="mb-0" *ngIf="!code.errors.required">Invalid Code</p>
            </small>
          </div>
          <div class="form-group">
            <label>New Password</label>
            <!-- <input type="password" class="form-control" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
              [(ngModel)]="resetPasswordModal.password" name="password" #password="ngModel" required> -->
            <input type="password" class="form-control" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[!@#$%^&*0-9a-zA-Z]{8,}"
              [(ngModel)]="resetPasswordModal.password" name="password" #password="ngModel" autocomplete="new-password" [disabled]="isMalformedEmail" required>
            <small class="text-danger text-center" *ngIf="password.errors && resetPasswordForm.submitted">
              <p class="mb-0" *ngIf="password.errors.required">Password is required</p>
              <p class="mb-0" *ngIf="!password.errors.required">{{passwordFormatError}}</p>
            </small>
          </div>

          <div class="form-group">
            <label>Confirm Password</label>
            <input type="password" class="form-control" [(ngModel)]="resetPasswordModal.confirmPassword"
              name="confirmPassword" #confirmPassword="ngModel" autocomplete="new-password" [disabled]="isMalformedEmail" required>
            <small class="text-danger text-center" *ngIf="confirmPassword.errors && resetPasswordForm.submitted">
              <p class="mb-0" *ngIf="confirmPassword.errors.required">Confirm Password is required</p>
            </small>
          </div>

          <div class="maroon forgot-password mt-3">
            <span data-toggle="modal" data-target="#resendCode" data-backdrop="static" data-keyboard="false">Resend
              code</span>
            <span class="pointer pull-right" (click)="naviagteToLogin()">
              Go to Login
            </span>
          </div>

          <div class="text-center mt-3">
            <button type="button" [disabled]="isMalformedEmail" (click)="naviagteToLogin()" class="btn btn-light border btn-80">Cancel</button>
            <button type="submit" [disabled]="isMalformedEmail" class="btn btn-primary border ml-2 btn-80">Submit</button>
          </div>
        </form>

        <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
  </div>

</div>

<!-- Modal Resend code -->
<div class="modal fade" id="resendCode" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="resendCodeTitle">Resend Code</h5>
        <button id="closeResendCode" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="resetResendCodeForm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form name="resendCodeForm" #resendCodeForm="ngForm" novalidate (ngSubmit)="getConfirmationCode(resendCodeForm)">
        <div class="modal-body fix-height-20">
          <div class="form-group" *ngIf="!isMalformedEmail">
            <label>The confirmation code will be sent to the below username/email</label>
            <input type="email" class="form-control" autocomplete="off" [(ngModel)]="resendCodeModal.username"
              name="username" #username="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$" readonly required>
            <small class="text-danger text-center" *ngIf="username.errors && resendCodeForm.submitted">
              <p class="mb-0" *ngIf="username.errors.required">Email is required</p>
              <p class="mb-0" *ngIf="!username.errors.required">Invalid Email</p>
            </small>
          </div>

          <div class="form-group" *ngIf="isMalformedEmail">
            <label>Please enter your username/email to get the confirmation code</label>
            <input type="email" class="form-control" autocomplete="off" [(ngModel)]="resendCodeModal.username"
              name="username" #username="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$" required>
            <small class="text-danger text-center" *ngIf="username.errors && resendCodeForm.submitted">
              <p class="mb-0" *ngIf="username.errors.required">Email is required</p>
              <p class="mb-0" *ngIf="!username.errors.required">Invalid Email</p>
            </small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
            (click)="resetResendCodeForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">OK</button>
        </div>
      </form>
    </div>
  </div>
</div>